import moment from "moment"

const CALENDAR_SETTINGS = {
  type: "date",
  firstDayOfWeek: 1,
  today: true,
  monthFirst: false,
  text: {
    days: ["dom", "seg", "ter", "qua", "qui", "sex", "sab"],
    months: ["Janeiro", "Fevereiro", "Março", "Abril", "Maio", "Junho", "Julho", "Agosto", "Setembro", "Outubro", "Novembro", "Dezembro"],
    monthsShort: ["Jan", "Fev", "Mar", "Abr", "Mai", "Jun", "Jul", "Ago", "Set", "Out", "Nov", "Dez"],
    today: "Hoje",
    now: "Agora",
    am: "AM",
    pm: "PM"
  },
  formatter: {
    date: (date, settings) => moment(date).format("DD/MM/YYYY"),
  },
}

export default class Calendar {

  static init(id, settings) {

    $(id).calendar({
      ...CALENDAR_SETTINGS,
      ...settings,
    })

    $(".date").prop("type", "tel")
    $(".date").mask("00/00/0000")
  }

  static initInputs() {

    $(".ui.calendar").calendar(CALENDAR_SETTINGS)

    $(".date").prop("type", "tel")
    $(".date").mask("00/00/0000")
  }
}
